import { useStytch, useStytchUser, useStytchSession } from "@stytch/react";

export { useStytch, useStytchUser, useStytchSession };

export function useIsAuthReady(): boolean {
  const { isInitialized } = useStytchUser<false>();
  return isInitialized;
}
